import { ApiMethod } from '@wajeez-web/stores/base';
import { AppWatch, appWatchClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export interface DateRangeRequest {
  fromDate?: string;
  toDate?: string;
}

export const getWeeklyActiveUsers: ApiMethod<
  DateRangeRequest,
  AppWatch.WeeklyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_activeReadersWeeklyBreakdown_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getMonthlyActiveUsers: ApiMethod<
  DateRangeRequest,
  AppWatch.MonthlyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_activeReadersMonthlyBreakdown_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyActiveUsersCount: ApiMethod<
  DateRangeRequest,
  AppWatch.DailyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_dailyActiveUsersCount_V1(
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
